import { useScopedTranslate } from '@locale/translate';

import { ViewSettingsModal } from './view-settings-modal';

import { TableView } from '../types';

const MAX_NAME_LENGTH = 255;
const COPY_SUFFIX = ' [copy]';
const MAX_BASE_LENGTH = MAX_NAME_LENGTH - COPY_SUFFIX.length;

export const DuplicateViewModal = ({
  view,
  createView,
}: {
  view: TableView;
  createView: (newView: TableView) => void;
}) => {
  const { t } = useScopedTranslate(locale);
  const baseName = view.name ?? t('defaultView');

  return (
    <ViewSettingsModal
      defaultName={`${baseName.slice(0, MAX_BASE_LENGTH)}${COPY_SUFFIX}`}
      defaultIsCollaborative={view.isCollaborative !== false}
      skipChangeRequirement
      onSave={(name, isCollaborative) =>
        createView({ ...view, id: `view-${Date.now()}`, name, isCollaborative })
      }
    />
  );
};

const locale = {
  en: { defaultView: 'Default view' },
  is: { defaultView: 'Sjálfgefin ásýnd' },
};
